
<script>
import Accommodations from './views/Accommodations.vue'
import AccommodationsForm from './views/AccommodationsForm.vue'
import PopupPenalties from '@/components/views/penalties/PopupPenalties.vue'
import {
  description,
  photo
} from './ui'
import editIcon from '@/assets/images/icons/pencil.svg?inline'
import starIcon from '@/assets/images/icons/star.svg?inline'
import locationIcon from '@/assets/images/icons/location.svg?inline'
import heartIcon from '@/assets/images/icons/heart.svg?inline'
import removeIcon from '@/assets/images/icons/cancel.svg?inline'
import arrowIcon from '@/assets/images/icons/arrow-down.svg?inline'

export default {
  name: 'cart-hotels',
  components: {
    Accommodations,
    AccommodationsForm,
    PopupPenalties,
    description,
    photo,
    editIcon,
    starIcon,
    locationIcon,
    heartIcon,
    removeIcon,
    arrowIcon
  },
  data: () => ({
    formIsShown: false,
    active: true
  }),
  computed: {
    hotels() {
      return this.$store.getters['cart/getHotels']
    },
    mainServiceIsHotel() {
      return this.$store.getters['cart/getMainService'] === 'hotels'
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    }
  },
  watch: {
    hotels: {
      handler(hotels) {
        if (this.mainServiceIsHotel) {
          hotels.forEach((hotel, i) => {
            if (hotel.accommodations.isLoading && !hotel.accommodations.collection.length) {
              this.getAccommodations(hotel.form, hotel.info.id, i)
            }
          })
        }
      },
      deep: true
    }
  },
  methods: {
    toggleForm() {
      this.formIsShown = !this.formIsShown
    },
    hideForm() {
      this.formIsShown = false
    },
    getAccommodations(form, hotelId, hotelIndex) {
      this.$store.dispatch('cart/getHotelAccommodations', {
        hotelIndex,
        hotelId,
        form
      })
    },
    toggleTourHotels() {
      this.active = !this.active
    }
  }
}
</script>

<template>
  <div class="cart__services--item">
    <div
      v-if="mainServiceIsHotel"
      class="cart__item-header"
    >
      <h3>Отели</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="toggleForm"
        >
          <removeIcon
            v-if="formIsShown"
            fill="#ffffff"
          />
          <editIcon
            v-else
            fill="#ffffff"
          />
          <span>
            {{ formIsShown ? 'Закрыть без изменений' : 'Изменить' }}
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="mainServiceIsTours"
      class="cart__item-header"
      :class="{ 'cart__item-header--empty-tour': !active }"
    >
      <h3>Отели</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="toggleTourHotels"
        >
          <arrowIcon
            fill="#ffffff"
            class="cart__item-header--arrow-icon"
            :class="{ 'cart__item-header--arrow-icon-rotate': active }"
          />
        </div>
      </div>
    </div>
    <div
      v-if="active"
    >
      <div
        v-for="(hotel, index) in hotels"
        :key="hotel.info.id"
        class="cart__main"
      >
        <b-loading
          v-if="hotel.isLoading"
          :is-full-page="false"
          :active="hotel.isLoading"
        />
        <div
          v-if="!hotel.isLoading"
        >
          <div class="cart__item-content">
            <accommodations-form
              :is-locked="!formIsShown"
              :hotel-id="hotel.info.id"
              :hotel-index="index"
            />
            <div class="cart__hotel">
              <photo
                :data="hotel.info.photos"
              />
              <div class="cart__hotel-info">
                <h2 class="cart__hotel-info-title">
                  {{ hotel.info.name }}
                </h2>
                <div class="cart__hotel-info-is-favorite">
                  <heart-icon
                    stroke="#DADADA"
                  />
                </div>
                <div class="cart__hotel-info-rating">
                  <div class="cart__hotel-info-stars">
                    <starIcon
                      v-for="i in hotel.info.category"
                      :key="`star_${i}`"
                    />
                  </div>
                </div>
                <p class="cart__hotel-info-location">
                  <location-icon
                    fill="#ABABAB"
                  />
                  <span>{{ hotel.info.city.name }}</span>
                </p>
                <description
                  v-if="hotel.info.description.short"
                  :description="hotel.info.description"
                />
              </div>
              <div class="cart__hotel-additional-info">
                <div class="cart__hotel-additional-info-item">
                  <div
                    v-if="hotel.info.rating"
                    class="cart__hotel-additional-info-rating"
                  >
                    {{ hotel.info.rating }}/100
                  </div>
                  <popup-penalties
                    :ids="{
                      hotelId: hotel.info.id,
                      accommodationSearchId: hotel.accommodations.searchId,
                      accommodationId: hotel.accommodations.current.id
                    }"
                    store-module="cart"
                    service-name="hotels"
                    :target="`hotels.${index}`"
                    api-module-name="cart"
                  />
                </div>
                <div
                  v-for="(fact, i) in hotel.info.facts.main"
                  :key="`${fact.slug}_${i}`"
                  class="cart__hotel-facts-item"
                >
                  <img
                    :src="fact.iconUrl"
                  >
                  <p>{{ fact.name }} {{ fact.value }}</p>
                </div>
              </div>
            </div>
            <accommodations
              v-if="!formIsShown"
              :hotel-id="hotel.info.id"
              :hotel-index="index"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
